module.exports = __webpack_public_path__ + "static/media/bg.5d40dcfc.svg";